import angular from 'angular';
import template from './template.html';

export class RegisterComponent {}

export const RegisterComponentConfiguration = {
    template,
    controller: RegisterComponent,
};

angular.module('TALENYA-FE').component('register', RegisterComponentConfiguration);